var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AttendanceIcon from "./Icons";
const divStyle = {
    marginTop: "1em",
};
const AttendanceTrend = (_a) => {
    var { trend, className } = _a, otherProps = __rest(_a, ["trend", "className"]);
    return (_jsx("div", Object.assign({}, otherProps, { style: divStyle, className: "d-flex " + (className || ""), children: trend.map((t, index) => (_jsx(AttendanceIcon, { className: "ml-2", attendanceStatusId: t.status, isCancelled: t.isCancelled, date: t.date }, index))) })));
};
export default AttendanceTrend;
